/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Title_PlaceholderInputs */

const en_admin_categories_title_placeholder = /** @type {(inputs: Admin_Categories_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Tutorials`)
};

const zh_admin_categories_title_placeholder = /** @type {(inputs: Admin_Categories_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 教程`)
};

/**
* | output |
* | --- |
* | "e.g. Tutorials" |
*
* @param {Admin_Categories_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_title_placeholder = /** @type {((inputs?: Admin_Categories_Title_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Title_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_title_placeholder(inputs)
	return zh_admin_categories_title_placeholder(inputs)
});
export { admin_categories_title_placeholder as "admin.categories.title_placeholder" }